import type { ReactElement } from 'react'
import { Link } from 'react-router'
import { useT } from '../../i18n/useI18n'
import { ACCOUNT_PATHS } from '../../account/accountPaths'
import { requestPasswordReset } from '../../account/accountApi'
import AccountLayout from './AccountLayout'
import { AccountNotice, EmailRequestForm } from './AccountParts'

export default function AccountForgotPassword(): ReactElement {
  const t = useT()
  return (
    <AccountLayout title={t('account.forgot.title')} lead={t('account.forgot.lead')}>
      <EmailRequestForm
        submitLabel={t('account.forgot.submit')}
        send={requestPasswordReset}
        renderDone={(email: string) => <AccountNotice title={t('account.forgot.sentTitle')}><p>{t('account.forgot.sentBody', { email })}</p></AccountNotice>}
      />
      <p className="ac-links"><Link to={ACCOUNT_PATHS.register}>{t('account.forgot.register')}</Link></p>
    </AccountLayout>
  )
}
